

//Get Windows size function
function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
}

// Hook
export const useSidebar = () => { 
    
    return {
    }
}